import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Icon, Table } from 'semantic-ui-react'

import Match from 'global-utils/models/sports/soccer/Match'

import './Minute.css'

class Minute extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      seconds: null,
    }
    this.timeout = null
  }

  componentDidMount() {
    this.startTimeout()
  }

  componentWillUnmount() {
    this.stopTimeout()
  }

  startTimeout = () => {
    const { match } = this.props
    this.stopTimeout()
    if (
      match &&
      !match.isEnded &&
      !match.isDeferred &&
      !match.isApproved &&
      match.time &&
      match.waitingTime < 60 * 60
    ) {
      this.timeout = setTimeout(this.startTimeout, 200)
      this.setState({
        seconds: match.time,
      })
    }
  }

  stopTimeout = () => {
    clearTimeout(this.timeout)
  }

  render() {
    const { environment, match, printable } = this.props
    const { seconds } = this.state

    const smallDevice = environment.stage.small
    const tinyDevice = environment.stage.tiny

    if (!match) {
      return null
    }

    let status = 'todo'
    let icon = 'time'
    let min = match.minutes || seconds || 0

    switch (match.status) {
      case 'done': {
        icon = 'edit'
        min = '90+'
        status = 'done'
        break
      }
      case 'todo': {
        min = '...'
        if (match.date && !match.isDeferred) {
          min = match.date.format('HH:mm')
        }
        break
      }
      // case 'doing':
      default: {
        icon = 'hourglass half'
        min += "'"
        status = 'doing'
      }
    }

    if (match.isApproved) {
      icon = 'check circle outline'
      status = 'approved'
    } else if (match.isEnded) {
      icon = 'edit'
      status = 'done'
    }

    if (printable) {
      min = match.date ? match.date.format('HH:mm') : ''
    }

    return (
      <Table.Cell className={`MatchMinute match ${status}`} title={match.dateForHumans()}>
        {!printable && !smallDevice && <Icon className={`MatchMinute__icon ${status}`} name={icon} />}
        {tinyDevice ? <small>{min}</small> : min}
      </Table.Cell>
    )
  }
}

Minute.propTypes = {
  environment: PropTypes.object.isRequired,
  match: PropTypes.instanceOf(Match).isRequired,
  printable: PropTypes.bool,
}

Minute.defaultProps = {
  printable: false,
}

export default connect(({ environment }) => ({ environment }))(Minute)
